export const ageMethod = "age nearest";
export const gateway = "https://qat-wpg-plan-shopper-api.link-nonprod.wawanesalife.com";
export const assets = "https://qat-assets.link-nonprod.wawanesalife.com/brokers/wpg-plan";
export const googleApiKey = "AIzaSyD8GAXLH7FxUmF13tfHgXVAU6fWk66UH3k";
export const appToken = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJ3cGctcGxhbiIsIm5hbWUiOiJ3cGctcGxhbiIsImlhdCI6MTc4MzUyOTc0NiwiZXhwIjoxOTQxMzE3NzQ2fQ.OmpADwUjsVo1FlR2KItStFyq_mLcn0KkkaE6PFTHsi8";
export const brokerConfig = {
	enabled: "yes",
	"split": '0.6'
};
export const brokerBranding = {
	"qat-wpg-plan-shopper.link-nonprod.wawanesalife.com": {
		a: {
			approve_company: "MANITOBA",
			approve_user: "link_wpg-plan",
			brands: [
				"qat-wpg-plan-shopper.link-nonprod.wawanesalife.com",
			],
			broker: "wpg-plan",
			broker_formatted_name: "The Wealth Planning Group",
			email: "insurance@wpg-plan.com",
			environment: "qat",
			environment_id: "qat",
			layout: "modern",
			logoPosition: "menu",
			menuPhone: "button",
			phone: "1.204.989.7676",
			privacyLink: "https://wpg-plan.com/privacy",
			website: "https://wpg-plan.com/",
			scope: "wpg-plan#branding#qat-wpg-plan-shopper.link-nonprod.wawanesalife.com#a",
			ab: "a",
			logo: "a.png",
			brand_name: "qat-wpg-plan-shopper.link-nonprod.wawanesalife.com",
		},
		b: {
			approve_company: "MANITOBA",
			approve_user: "link_wpg-plan",
			brands: [
				"qat-wpg-plan-shopper.link-nonprod.wawanesalife.com",
			],
			broker: "wpg-plan",
			broker_formatted_name: "The Wealth Planning Group",
			email: "insurance@wpg-plan.com",
			environment: "qat",
			environment_id: "qat",
			layout: "modern",
			logoPosition: "menu",
			menuPhone: "button",
			phone: "1.204.989.7676",
			privacyLink: "https://wpg-plan.com/privacy",
			website: "https://wpg-plan.com/",
			scope: "wpg-plan#branding#qat-wpg-plan-shopper.link-nonprod.wawanesalife.com#b",
			ab: "b",
			logo: "b.png",
			brand_name: "qat-wpg-plan-shopper.link-nonprod.wawanesalife.com",
		},
	},
};

//updated on Wed Jul 08 2026 11:55:46 GMT-0500 (Central Daylight Time)
